import React from 'react'

import { Col, Grid } from '../structure/Grid'
import CalendarDatePicker from './CalendarDatePicker'
import CalendarPerspectivePicker from './CalendarPerspectivePicker'

const CalendarNavigation = () => {
  return (
    <Grid gap={0.4} justify="space-between" align="center">
      <Col width="20%" />
      <CalendarDatePicker />
      <Col width="20%" justify="flex-end" direction="row">
        <CalendarPerspectivePicker />
      </Col>
    </Grid>
  )
}

export default CalendarNavigation
